import { render, staticRenderFns } from "./ListDeals.vue?vue&type=template&id=b3ae9c58&scoped=true"
import script from "./ListDeals.vue?vue&type=script&lang=js"
export * from "./ListDeals.vue?vue&type=script&lang=js"
import style0 from "./ListDeals.vue?vue&type=style&index=0&id=b3ae9c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ae9c58",
  null
  
)

export default component.exports